const TaskState = {
    NOT_TAKEN: 0,
    TAKEN: 1,
    MY_TASK: 2,
    MY_COMPLETED: 3,
    TAKEN_COMPLETED: 4,
}
export default TaskState;
